import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import FinalistCard from "@/components/feature/FinalistCard";
import { finalists } from "@/mocks/finalists";

export default function HotCandidates() {
  const hot = finalists.slice(0, 6);

  return (
    <section id="hot" className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="mx-auto max-w-6xl">
          <SectionHeading
            eyebrow="热门候选"
            title="当前评分领跑的入围作品"
            desc="以下作品在本轮群众打分中表现突出，点击进入评选专区可以看到完整入围名单与全部得分。"
            action={
              <Link
                to="/finalists"
                className="shrink-0 px-5 py-2.5 rounded-md border border-foreground-300 text-foreground-800 text-sm font-medium whitespace-nowrap hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer"
              >
                查看全部入围名单
              </Link>
            }
          />

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {hot.map((item) => (
              <FinalistCard key={item.id} item={item} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}